var _path, _path2, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNavigationIconTopGrossing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "24px-top-grossing-01") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19,11c-.09-4-5.74-8.31-6.39-8.8L11,1V3c0,2.27-1.92,3.75-3.61,5.06C6.15,9,5.07,9.86,5,11H2V23H22V11ZM4,18.59V15.41L6.41,13H17.59L20,15.41v3.18L17.59,21H6.41ZM8.62,9.64C10.08,8.51,12,7,12.7,4.87,14.49,6.45,16.91,9,17,11H15a4.29,4.29,0,0,0-1.07-2.19l-.7-.93-.81.83a28,28,0,0,1-2.65,2.21L9.66,11H7.07A10.21,10.21,0,0,1,8.62,9.64Z",
    fill: "#343434"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12,14a3,3,0,1,0,3,3A3,3,0,0,0,12,14Zm0,4a1,1,0,1,1,1-1A1,1,0,0,1,12,18Z",
    fill: "#343434"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 3,
    width: 2,
    height: 3,
    fill: "#343434"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    width: 2,
    height: 2,
    fill: "#343434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationIconTopGrossing);
export default __webpack_public_path__ + "static/media/navigation-icon-top-grossing.61fee494549d204306a66a8324dbef2c.svg";
export { ForwardRef as ReactComponent };